import { render } from "./ProductUpdatePhoto.vue?vue&type=template&id=0a20918a"
import script from "./ProductUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./ProductUpdatePhoto.vue?vue&type=script&lang=js"

import "../../../src/assets/css/avatar.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__